'use client'

import { usePathname } from 'next/navigation'
import { VersionUpdateBanner } from '@/components/version-update-banner'

interface VersionCheckerProps {
  initialVersion: string
}

/**
 * Conditionally renders the version update banner based on the current route.
 * Only shows on authenticated/dashboard pages, not on public pages.
 */
export function VersionChecker({ initialVersion }: VersionCheckerProps) {
  const pathname = usePathname()

  // Don't show on public pages
  const isPublicPage = 
    pathname === '/' || // Homepage
    pathname === '/login' ||
    pathname === '/signup' ||
    pathname === '/reset-password' ||
    pathname === '/onboarding' ||
    pathname === '/demo' ||
    pathname === '/discover' ||
    pathname === '/privacy' ||
    pathname === '/terms' ||
    pathname === '/contact' ||
    pathname === '/referrals' ||
    pathname === '/invite' ||
    pathname?.startsWith('/invite/') ||
    // Artist public pages (event audience views)
    (pathname?.match(/^\/[^/]+$/) && !pathname.match(/^\/(dashboard|admin|settings|select)/)) ||
    pathname?.match(/^\/[^/]+\/events\/[^/]+$/)

  // Only show on authenticated pages
  if (isPublicPage) {
    return null
  }

  return <VersionUpdateBanner initialVersion={initialVersion} />
}

